module.exports = __webpack_public_path__ + "img/nutrition.d3dee130.jpg";